
import React from 'react';

const WaveAnimation = () => {
  return (
    <div className="absolute bottom-0 left-0 w-full overflow-hidden">
      {/* First wave layer */}
      <div className="absolute bottom-0 left-0 w-full h-24">
        <div className="wave-bottom opacity-30 animate-wave" style={{ animationDuration: '15s' }} />
      </div>
      {/* Second wave layer */}
      <div className="absolute bottom-0 left-0 w-full h-20">
        <div className="wave-bottom opacity-50 animate-wave" style={{ animationDuration: '10s', animationDelay: '-2s' }} />
      </div>
      {/* Third wave layer */}
      <div className="absolute bottom-0 left-0 w-full h-16">
        <div className="wave-bottom animate-wave" style={{ animationDuration: '7s', animationDelay: '-4s' }} />
      </div>
    </div>
  );
};

export default WaveAnimation;
